export const ROLES_PERMISSIONS = {
  BOT: {
    ACTIVATE_BOT: 'activate:bot'
  },
  COMPANIES: {
    ACTIVATE_COMPANY: 'activate:company',
    ACTIVATE_PRODUCT: 'activate:product',
    ADD_ACCOUNT_STATEMENTS: 'create:account_statement',
    ADD_BANK_ACCOUNTS: 'create:bank_account',
    ADD_TRADING_ACCOUNTS: 'create:trading_account',
    CHANGE_ACCOUNT_STATE: 'change:account_state',
    CHANGE_COMPANY_GRADES: 'change:company_grade',
    COMMENT_COMPANY: 'comment:company',
    DEACTIVATE_COMPANY: 'deactivate:company',
    DEACTIVATE_PRODUCT: 'deactivate:product',
    EDIT_COMPANY_CONTACTS: 'edit:company_contact',
    EDIT_COMPANY_PRICING: 'edit:company_pricing',
    EDIT_TRADING_ACCOUNTS: 'edit:trading_account',
    READ_COMPANIES: 'read:company',
    READ_COMPANY_CONFIG: 'read:company_config',
    EDIT_COMPANY_CONFIG: 'edit:company_config',
    READ_COMPANY_CONTACTS: 'read:company_contact',
    SUSPEND_COMPANY: 'suspend:company',
    UNSUPEND_COMPANY: 'unsuspend:company',
    EDIT_FINANCING_INDICATOR: 'edit:financing_indicator',
    RUN_COMPANY_CHECKS: 'run:company_checks'
  },
  CREDIT_NOTE: {
    READ_CREDIT_NOTE: 'read:credit_note'
  },
  DEBT_COLLECTION: {
    EDIT_DC_CASES: 'edit:dc_case',
    READ_DC_CASES: 'read:dc_case',
    READ_DC_FLOWS: 'read:dc_flow'
  },
  ETR: {
    APPROVE_ETRS: 'approve:etr',
    CANCEL_ETRS: 'cancel:etr',
    READ_ETRS: 'read:etr',
    DOWNLOAD_ETRS_CERTIFICATES: 'download:trade_certificate'
  },
  ETP: {
    READ: 'read:etp',
    CANCEL: 'cancel:etp',
    DEFAULT: 'default:etp',
    PLACE_ORDER: 'place:etp_order',
    WRITE_OFF: 'write_off:etp'
  },
  PAYABLE: {
    READ: 'read:payable',
    APPROVE: 'approve:payable',
    REJECT: 'reject:payable'
  },
  INVESTORS: {
    ACTIVATE_STRATEGY: 'activate:strategy',
    EDIT_STRATEGIES: 'edit:strategy',
    READ_STRATEGIES: 'read:strategy',
    READ_PRICING: 'read:pricing',
    EDIT_PRICING: 'edit:pricing',
    READ_POSITIONS: 'read:investor_positions',
    READ_ACCOUNT_STATEMENTS: 'read:investor_account_statement'
  },
  INVOICE: {
    APPROVE_INVOICE: 'approve:invoice',
    COMMENT_INVOICE: 'comment:invoice',
    EXPORT_INVOICE: 'export:invoice',
    PENDING_INVOICE: 'pending:invoice',
    READ_INVOICE: 'read:invoice',
    RECHECK_INVOICE: 'recheck:invoice',
    REJECT_INVOICE: 'reject:invoice',
    SELL_INVOICE: 'sell:invoice',
    UPLOAD_INVOICE: 'upload:invoice',
    WRITE_OFF_INVOICE: 'write_off:invoice'
  },
  LEADS: {
    CREATE_LEADS: 'create:lead',
    APPROVE_LEADS: 'approve:lead',
    COMMENT_LEADS: 'comment:lead',
    READ_LEADS: 'read:lead',
    REJECT_LEADS: 'reject:lead',
    RESET_LEADS: 'reset:lead'
  },
  MARKET: {
    ACTIVATE_MARKETS: 'activate:market',
    CREATE_ORDER: 'create:order',
    READ_MARKETS: 'read:market'
  },
  MATCHING: {
    ADD_COMMENTS: 'comment:matching_payment',
    FORWARD_PAYMENT: 'forward:matching_payment',
    READ_MATCHING_PAYMENTS: 'read:matching_payment',
    RESOLVE_PAYMENT: 'resolve:matching_payment',
    SETTLE: 'settle:invoice',
    UNMATCH_PAYMENT: 'unmatch:matching_payment'
  },
  PARTNERS: {
    CREATE_PARTNER: 'create:partner',
    EDIT_PARTNER: 'edit:partner',
    EDIT_PARTNER_PRICING: 'edit:partner_pricing',
    READ_PARTNERS: 'read:partner'
  },
  SETTLEMENT_LOCK: {
    ACCEPT_SETTLEMENT_LOCK: 'accept:settlement_lock',
    KEEP_PROCEEDS_SETTLEMENT_LOCK: 'keep_proceeds:settlement_lock',
    READ_SETTLEMENT_LOCK: 'read:settlement_lock',
    REJECT_SETTLEMENT_LOCK: 'reject:settlement_lock'
  },
  TRADES: {
    ACCEPT_TRADE_LOCK: 'accept:trade_lock',
    KEEP_PROCEEDS_TRADE_LOCK: 'keep_proceeds:trade_lock',
    READ_TRADE_LOCK: 'read:trade_lock',
    REJECT_TRADE_LOCK: 'reject:trade_lock'
  },
  ROLE_MANAGEMENT: {
    READ_PERMISSION: 'read:permission',
    CREATE_PERMISSION: 'create:permission',
    EDIT_ROLE_PERMISSION: 'edit:role_permission',
    READ_ROLE: 'read:role',
    CREATE_ROLE: 'create:role',
    EDIT_ROLE: 'edit:role'
  }
}
